import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';


@Component({
  selector: 'my-requesttype-file-grid',
  templateUrl: './RequestTypeFileGrid.component.html'
})
export class RequestTypeFileComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    records: ent.RequestTypeFile[];
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private exportService: serv.ExportService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'RequestTypeID', header: 'Request Type ID' },
            { field: 'RequestType.Name', header: 'Request Type' },
            { field: 'FileID', header: 'Export File ID' },
            { field: 'ExportFile.Name', header: 'Export File Name' },
            
        ];

    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        this.exportService.getRequestTypeFiles().subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    
    
}